import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from '@blocs.i18n';
import { truncateAndAddEllipsis } from '@consumer-talent.utils/helpers';

export const AccountPhotoPlaceholder = styled.div`
  height: 2.5rem;
  flex: 0 0 2.5rem;
  line-height: 2.5rem;
  margin-left: 0;
  margin-right: 1rem;
  background-color: ${(props) => props.theme.colors.primary.grey2};
  color: ${(props) => props.theme.colors.primary.white};
  text-align: center;
  display: inline-block;
`;

export const StageName = styled.div`
  vertical-align: middle;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  font-weight: 700;
  line-height: 1.25;
`;

export const AccountWrapper = styled.div`
  white-space: nowrap;
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
`;

type AccountInfoProps = {
  firstName: string;
  lastName: string;
};

const AccountInfo: FC<AccountInfoProps> = ({ firstName, lastName }) => {
  const { t } = useTranslation();
  const firstNameInitial = firstName ? firstName[0].toUpperCase() : '';
  const lastNameInitial = lastName ? lastName[0].toUpperCase() : '';
  const stageName = truncateAndAddEllipsis(t('common:formattedName.firstLast', { firstName, lastName }), 14);

  return (
    <AccountWrapper>
      <AccountPhotoPlaceholder data-qa-id="account-info-photo-placeholder">
        {t('common:formattedName.firstLastInitial', { firstNameInitial, lastNameInitial })}
      </AccountPhotoPlaceholder>
      <StageName data-qa-id="account-info-stage-name">{stageName}</StageName>
    </AccountWrapper>
  );
};

export default AccountInfo;
